/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import ReducerIndex from 'qwc2/reducers/index';
import layersReducer from '../reducers/layersext';
ReducerIndex.register("layers", layersReducer);

export const SET_LEVELFILTER = 'SET_LEVELFILTER';
export const SET_LAYERFILTERS = 'SET_LAYERFILTERS';
export const REGISTER_FILTERS = 'REGISTER_FILTERS';

export function setLayerFilters(filters) {
    return {
        type: SET_LAYERFILTERS,
        filters
    };
}

export function setLevelfilter(levelFilter) {
    return {
        type: SET_LEVELFILTER,
        levelFilter
    };
}

export function registerFilters(filters) {
    return {
        type: REGISTER_FILTERS,
        filters
    };
}
